export class UserAPIRiskSummary {
  public riskId: string;
  public vehicleId: string;
  public riskDescription: string;
  public vinSerialNumber: string;
  public poiLink?: string;
  public riskSequenceNumber?: number;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    this.vehicleId = json.vehicleId;
    this.riskId = json.riskId;
    this.riskDescription = json.riskDescription;
    this.vinSerialNumber = json.vinSerialNumber;
    if (json.riskSequenceNumber) this.riskSequenceNumber = json.riskSequenceNumber;
  }
}
